import { useEffect, useState } from "react";
import { Home, Ref, Schedule } from "./components";
import {
  Tooltip,
  Breadcrumbs,
  Link,
  Typography,
  Slide,
  Fade,
} from "@material-ui/core";
import { parseString } from "xml2js";
import "@fortawesome/fontawesome-free/js/all";
import "./App.scss";

function App() {
  const [data, setData] = useState(null);
  useEffect(() => {
    try {
      let wheel = false;
      const App = document.querySelector(".App");
      window.App = App;
      App.addEventListener("wheel", (e) => {
        if (Math.abs(e.deltaY) < 1) return;
        if (wheel === true) {
          return;
        }
        const dont = e.target.closest("#scheduleTable");
        if (!dont) {
          // App.scrollLeft += e.deltaY * 1.1;
          // wheel = true;
          App.scroll({
            // left: App.scrollLeft + Math.sign(e.deltaY) * 300 * level,
            left: App.scrollLeft + e.deltaY,
            // behavior: "smooth",
          });
          setTimeout(() => {
            wheel = false;
          }, 50);
        }
      });
    } catch (err) {
      console.error(err);
    }
  }, []);
  useEffect(() => {
    (async function () {
      const resp = await fetch("./assets/data/data.xml");
      const xml = await resp.text();
      parseString(xml, (err, res) => {
        if (err) {
          console.error(err);
        }
        setData(res);
      });
    })();
  }, []);

  const navHandler = (n) => {
    const homeLeft = 0;
    const refLeft = document.querySelector("#ref").offsetLeft;
    const scheduleLeft = document.querySelector("#schedule").offsetLeft;
    const App = document.querySelector(".App");
    switch (n) {
      case 0:
        App.scroll({
          left: homeLeft,
          behavior: "smooth",
        });
        break;
      case 1:
        App.scroll({
          left: refLeft,
          behavior: "smooth",
        });
        break;
      case 2:
        App.scroll({
          left: scheduleLeft,
          behavior: "smooth",
        });
        break;
      default:
        break;
    }
  };

  return (
    <div className="App">
      <header className="header">
        <Slide direction="right" in={true} timeout={500}>
          <div className="bc">
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="textPrimary" href="../../">
                All Courses
              </Link>
              <Link
                underline="hover"
                color="textPrimary"
                href="../"
              >
                Computer Vision
              </Link>
              <Typography color="textSecondary">
                CV {data && data.cvkntu.date[0]}
              </Typography>
            </Breadcrumbs>
          </div>
        </Slide>
        <Fade in={true} timeout={500}>
          <div className="navbar">
            <Tooltip title="Home">
              <span onClick={() => navHandler(0)}>
                <i className="fas fa-home" />
              </span>
            </Tooltip>
            <Tooltip title="References">
              <span onClick={() => navHandler(1)}>
                <i className="fas fa-book" />
              </span>
            </Tooltip>
            <Tooltip title="Schedule">
              <span onClick={() => navHandler(2)}>
                <i className="far fa-calendar-alt" />
              </span>
            </Tooltip>
          </div>
        </Fade>
      </header>
      <main className="main">
        {data && (
          <>
            <Home data={data.cvkntu} />
            <Ref data={data.cvkntu} />
            <Schedule data={data.cvkntu} />
          </>
        )}
      </main>
      <footer className="footer">
        <div>Behrooz Nasihatkon © 2022</div>
        <div>
          Powered by{" "}
          <Link href="https://alireza-kavian.github.io">Alireza Kavian</Link>
        </div>
        <div style={{ display: "none" }}>
          <a href="https://freepik.com/">Vector Credits</a>
        </div>
      </footer>
    </div>
  );
}

export default App;
